import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/{id}/public-availability', 'put'>;
type ResponseBody = OASOutput<O, '/api/projects/{id}/public-availability', 'put'>;

type Params = {
  id: number;
  isActive: boolean;
};

type Result = {
  publicIdentifier: string | null;
};

export const setProjectPublicAvailabilityFactory = (apiClient: ApiClient) => {
  const setProjectPublicAvailability = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects/{id}/public-availability'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      params: {
        id: input.id,
      },
      json: {
        isActive: input.isActive,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      publicIdentifier: response.publicIdentifier ?? null,
    };
  };

  return setProjectPublicAvailability;
};
